import type { JSX } from 'react';

import { CheckIcon, LinkIcon } from '@change/ds-icons';

import { Button } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import type { Props as MainProps } from '../../index';

import { useShareUrl } from './hooks/useShareUrl';

export function ShareUrlReskin({ viewContext }: { viewContext: MainProps['viewContext'] }): JSX.Element {
	const { data, actions } = useShareUrl(viewContext);

	return (
		<Button
			data-testid="copy-link-share-button"
			data-qa="copy-link-share-button"
			onClick={actions.handleShare}
			size="x-small"
			variant="secondary-solid"
			leadingIcon={<LinkIcon />}
			className="w-full md:w-auto"
		>
			<div className="flex flex-row items-center gap-1">
				{data.copied ? (
					<>
						<Translate value="corgi.petition.starter_dashboard.recommendations.copy_link.copy_success" />
						<CheckIcon size="small" className="text-icon-success" />
					</>
				) : (
					<Translate value="corgi.petition.starter_dashboard.recommendations.copy_link.copy_button" />
				)}
			</div>
		</Button>
	);
}
